import { findRecursive } from '@/mm/utils.js'

export function washData_relatedCarouselCase(walkedNode) {
  const ProNode = findRecursive(
    walkedNode.list,
    (item) => item.componentName === 'text_title',
    'list'
  )
  const buttonNode = findRecursive(
    walkedNode.list,
    (item) => item._type === 'button_text_1',
    'list'
  )
  if (walkedNode._type === 'related_carousel_case1') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  } else if (walkedNode._type === 'related_carousel_case2') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
  } else if (walkedNode._type === 'related_carousel_case3') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode) {
      if (!buttonNode.actions.find((item) => item === 'translate')) {
        buttonNode.actions.push('translate')
      }
    }
  } else if (walkedNode._type === 'related_carousel_case4') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (buttonNode) {
      if (!buttonNode.actions.find((item) => item === 'translate')) {
        buttonNode.actions.push('translate')
      }
    }
  }
}
